import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import portalRoutes from './portalRoutes'
import { isPortalDomain, isProduction } from '@/config/domainConfig'

// Sélectionner les routes appropriées selon le domaine et l'environnement
const selectedRoutes = isPortalDomain() ? portalRoutes : routes;

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: selectedRoutes,
  scrollBehavior() {
    return { top: 0 }
  },
})

// Navigation guard pour le portail (uniquement en production)
router.beforeEach((to, from, next) => {
  // Si on est en production et sur le domaine portail, rediriger toutes les routes non-portail vers la page principale
  if (isProduction() && isPortalDomain()) {
    // Vérifier si la route existe dans les routes du portail
    const portalRouteNames = portalRoutes.map(route => route.name);
    if (!portalRouteNames.includes(to.name) && to.name !== 'portal-not-found') {
      // Rediriger vers la page principale du portail
      next({ name: 'public-portal' });
      return;
    }
  }
  
  next();
});

export default router
